import { BASE_API_URL } from './index';
export const ssoSettingsBaseEndpoint = `${BASE_API_URL}/companies/settings/sso/`;
export const ssoSettingsByNamespaceBaseEndpoint = `${BASE_API_URL}/companies/settings/sso/namespace/`;
export const getSSOSettingsDetailEndpoint = (id) => `${ssoSettingsBaseEndpoint}${id}/`;
